<template>
    <div :style="{opacity: loaderOpacity}"
            class="disabling-loader"><div class="spinner"></div></div>
</template>

<script>
    export default {
        data() {
            return {
                loaderOpacity: 0
            }
        },
        created() {
            this.loaderOpacity = 0;
        },
        mounted() {
            this.loaderOpacity = 1;
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/LoaderItem.vue